export const tabHash={
    SEND_TO_CUSTOMER:"send-to-customer",
    INVOICE_HISTORY:"invoice-history",
    READY_FOR_BILLING:"ready-for-billing"
}